import _ from 'lodash';
import timeParser from '$$helpers/timeParser';
import BaselineGrid from '../baselines/grid';
import { getChildrenByTaskId } from '../helpers/ganttHelpers';

class Estimation {
  #instance = null;

  init(instance) {
    this.#instance = instance;
  }

  getEstimationValueForTask(task, isBaseline, baselineState, notFormatted = false) {
    if (task.type === this.#instance.config.types.button || task.type === this.#instance.config.types.milestone) {
      return '';
    }

    let totalEstimate = task.estimation;

    if (task.type === this.#instance.config.types.project) {
      totalEstimate = 0;

      if (isBaseline) {
        const originalChildren = getChildrenByTaskId(this.#instance, task.id);

        _.each(originalChildren, child => {
          const baselineTask = baselineState ? _.find(baselineState.tasks, bt => bt.id === child.id) : BaselineGrid.baselinesTasks[child.id];

          if (baselineTask && baselineTask.type === this.#instance.config.types.task) {
            totalEstimate += parseFloat(baselineTask.estimation);
          }
        });
      } else {
        this.#instance.eachTask(childTask => {
          if (childTask.type === this.#instance.config.types.task) {
            totalEstimate += parseFloat(childTask.estimation);
          }
        }, task.id);
      }
    }

    return notFormatted ? totalEstimate : timeParser.output(totalEstimate, {
      durationData: this.#instance.config.durationData,
      prop: 'estimation',
    });
  }
}

export default new Estimation();
